import { Directive } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '.carousel-item',
    standalone: false
})
export class CarouselItemElementDirective {}
